import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountDeleteComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    currentUser: api.UserAccount | null = null;

    view: string = 'loading';

    mounted() {
        if (this.$route.query.token) {
            this.$auth.deleteConfirm(this.$route.query.token as string).then(
                () => {
                    (<any>this.$root).$refs.dialogMessage.show({
                        title: i18next.t('label_account_deleted'),
                        text: i18next.t('label_account_deleted_details'),
                        persistent: true,
                        btnOkHandler: () =>
                        {
                            window.location.href = '/';
                        }
                    });
                },
                () => {
                    (<any>this.$root.$refs).signInPanel.$refs.modalSignIn.show();
                }
            );
        } else {
            window.location.href = '/';
        }
    }
}
